<template lang="pug">
.capital-market-publications-technical-error
	VueFeedback(type="error")
		template(slot="feedback-title") Technical error!
		template(slot="feedback-content")
			p A technical error occurred. Please try again later.
</template>

<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	components: {
		VueFeedback
	}
};
</script>
